export default "__VITE_ASSET__4a6a6aff__"